import { render, staticRenderFns } from "./moveCategoryForm.vue?vue&type=template&id=6b5a475a&scoped=true&"
import script from "./moveCategoryForm.vue?vue&type=script&lang=js&"
export * from "./moveCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./moveCategoryForm.vue?vue&type=style&index=0&id=6b5a475a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a475a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5a475a')) {
      api.createRecord('6b5a475a', component.options)
    } else {
      api.reload('6b5a475a', component.options)
    }
    module.hot.accept("./moveCategoryForm.vue?vue&type=template&id=6b5a475a&scoped=true&", function () {
      api.rerender('6b5a475a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/components/moveCategoryForm.vue"
export default component.exports